import { apiClient, API_ENDPOINTS } from '../config/api';
import { getActiveRoleFromStorage } from './getActiveRole';

const listOf = (data) => {
  if (Array.isArray(data)) return data;
  for (const key of ['data', 'documents', 'content', 'forms']) {
    if (data && Array.isArray(data[key])) return data[key];
  }
  return [];
};

/**
 * How many forms the transaction's Forms tab lists, from the same source that tab reads
 * (TransactionDocuments.fetchDocuments): CO → forms-service package, Lone Wolf-pinned →
 * Lone Wolf, client → DocuSign shared-with, otherwise DocuSign room documents. Lets the
 * sidebar show the right count as soon as the transaction loads. 0 on any failure.
 */
export const fetchTransactionFormsCount = async (transaction, headers) => {
  if (!transaction?.id) return 0;
  const role = (getActiveRoleFromStorage() || '').toUpperCase();
  const isClient = role === 'BUYER' || role === 'SELLER';
  try {
    if ((transaction.propertyState || '').toUpperCase() === 'CO') {
      const pkgResp = await apiClient.get(API_ENDPOINTS.formsPackagesByTransaction(transaction.id), { headers });
      const pkgs = listOf(pkgResp.data);
      const packageId = pkgs[0]?.packageId || pkgs[0]?.id;
      if (!packageId) return 0;
      const formsResp = await apiClient.get(API_ENDPOINTS.formsPackageForms(packageId), { headers });
      return listOf(formsResp.data).length;
    }
    if (transaction.esignatureProvider === 'LONEWOLF' && !isClient) {
      const formsResp = await apiClient.get(API_ENDPOINTS.lonewolfTransactionForms(transaction.id), { headers });
      return listOf(formsResp.data).length;
    }
    if (isClient) {
      const resp = await apiClient.get(API_ENDPOINTS.transactionDocusignDocumentsSharedWith(transaction.id), { headers });
      return (resp.data?.envelopes || []).reduce((sum, env) =>
        sum + (env.documents || []).filter((d) => d.type !== 'summary' && d.documentId !== 'certificate').length, 0);
    }
    const resp = await apiClient.get(API_ENDPOINTS.transactionDocusignDocuments(transaction.id), { headers });
    return listOf(resp.data).length;
  } catch (e) {
    console.warn('[FormsCount] Could not count forms', e?.response?.status || e?.message);
    return 0;
  }
};
